document.addEventListener('DOMContentLoaded', () => {
  var prm = location.search
  if(!prm.includes('pvnum')) {
    return false
  } else {
    var num = prm.slice(-1);
    const target = document.querySelector('.Outfit-category-outer')
    target.children[num].querySelector('.popup').classList.add('active')
  }
})

$(window).on('load', function() {
  const target = $('[data-popup-link]')
  target.each(function(index) {
    $(this).click(function() {
      $(this).next('.popup').addClass('active')
    })
  })
})

$(window).on('load', function() {
  const target = $('.popup-bg')
  target.each(function() {
    $(this).click(function() {
      $(this).parents('.popup').removeClass('active')
    })
  })
})


const addClassEvent = () => {
  const targetPvideo = document.querySelectorAll('[data-pvideo]')
  
  for(let i = 0; i < targetPvideo.length; i++) {
    if(targetPvideo[i].children.length >= 4) {
      targetPvideo[i].classList.remove('justify-content-md-center')
    }
  }
}
addClassEvent()

const cloneCautionText = () => {
  const target = document.querySelector('[data-caution-text]')
  target.remove()
  const cloneDom = document.querySelectorAll('[data-caution-target]')
  for(let i = 0; i < cloneDom.length; i++) {
    if(cloneDom[i].querySelector('[data-pvideo]')) {
      const clone_target = target.cloneNode(true);
      cloneDom[i].appendChild(clone_target);
    }
  }
}
cloneCautionText()